import { HttpClient } from '@angular/common/http';
import { Component, EventEmitter, Input, Output } from '@angular/core';
import { Auth } from 'aws-amplify';
import { finalize } from 'rxjs';
import { APIService, Billing, GetTokensQuery } from 'src/app/API.service';
import { D2TApi } from 'src/app/doc2txt/utils/d2tApi';
import { UserBillingStatus } from 'src/app/doc2txt/utils/userBillingStatus';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'user-payment-sum',
  templateUrl: './user-payment-sum.component.html',
  styleUrls: ['./user-payment-sum.component.css'],
})
export class UserPaymentSumComponent {
  @Input() userBillingStatus: UserBillingStatus | null;
  @Input() tokenType: string | null | undefined;
  @Input()  loadingFlag: boolean;
  @Output() loadingFlagChange = new EventEmitter<boolean>();

  user: any;
  token: GetTokensQuery;
  constructor(private http: HttpClient, private api: APIService) {}

  async ngOnInit() {
    this.user = await Auth.currentUserInfo();

    this.token = await this.api.GetTokens(this.user.username);
  }
  showBillPdf(bill: Billing) {
    const d2tApi = new D2TApi(this.http, this.token);
    this.loadingFlagChange.emit(true)
    const request$ = d2tApi.getBillInvoicePdf(bill.id);
    request$
      .pipe
      // finalize(() => {
      //   this.loadingFlag = false;
      // })
      ();
    request$.subscribe((data: any) => {
      this.loadingFlagChange.emit(false)

      if (data.error) {
        alert(data.error);
        return;
      }
      if (data.body) {
        let pdfWindow = window.open('');
        if (pdfWindow) {
          pdfWindow.document.write(
            "<iframe width='100%' height='100%' src='data:application/pdf;base64, " +
              encodeURI(data.body) +
              "'></iframe>"
          );
        }
      } else {
        alert('showBillPdf failed: data.body is null');
      }
    });
    // throw new Error('Method not implemented.');
  }
}
